module.exports = __webpack_public_path__ + "media/images/expe2-82545ddcad680c1535d7db1685fef93c.svg";